import React, { useState, useTransition } from "react";
import Header from "../Header/Header";
import s from "./Balance.module.scss";
import {
  Button,
  DatePicker,
  Dropdown,
  Input,
  Modal,
  Popconfirm,
  Space,
  Table,
} from "antd";
import type { ColumnsType } from "antd/es/table";
import type { MenuProps, TableProps } from "antd";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import moment from "moment";
import {
  addPartnerBalance,
  getTransactionsHistory,
  reducePartnerBalance,
} from "../../redux/BillingSlice";
import dayjs, { Dayjs } from "dayjs";
import { NumericFormat } from "react-number-format";
import Footer from "../Footer/Footer";
import MobileHeader from "../MobileHeader/MobileHeader";
import useWindowDimensions from "../WindowDimensions/WindowDimensions";
import { useTranslation } from "react-i18next";

const { RangePicker } = DatePicker;

interface ITable {
  number: number;
  application?: {
    id: number;
    application_number: string;
  };
  transaction_type?: string;
  date: string;
  amount: any;
  row_balance: string;
}

const Balance = () => {
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  const partnerBalance = useSelector(
    (state: RootState) => state.billing.partnerBalance
  );
  const alltransactions = useSelector(
    (state: RootState) => state.billing?.transactions
  );
  const user = useSelector((state: RootState) => state.user.user);

  const [dates, setDates] = useState<any>(null);
  const [startDate, setStartDate] = useState<string>();
  const [endDate, setEndDate] = useState<string>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [balanceToAdd, setBalanceToAdd] = useState(0);
  const [balanceToReduce, setBalanceToReduce] = useState(0);
  const [isReduceModalOpen, setIsReduceModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleChange = (values: any) => {
    setDates(values);
    if (values) {
      setStartDate(values[0]?.format("YYYY-MM-DD"));
      setEndDate(values[1]?.format("YYYY-MM-DD"));
    }
  };

  const showReduceModal = () => {
    setIsReduceModalOpen(true);
  };

  const handleReduceCancel = () => {
    setIsReduceModalOpen(false);
  };

  const onChange: TableProps<ITable>["onChange"] = (
    pagination,
    filters,
    sorter,
    extra
  ) => {};
  const columns: ColumnsType<ITable> = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("Номер заявки"),
      dataIndex: `application_number`,
      width: 130,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Дата оплаты"),
      dataIndex: `date`,
      width: 70,
      render: (text) => <div className={s.font}>{text}</div>,
    },
    {
      title: t("Назначение платежа"),
      dataIndex: `transaction_type`,
      width: 150,
      render: (text) => (
        <div>
          {text === "payment" ? (
            t("Оплата")
          ) : text === "credit" ? (
            <div style={{ color: "rgb(72, 157, 72)" }}>{t("Пополнение")}</div>
          ) : (
            <div style={{ color: "#FA5F55" }}>{t("Списание")}</div>
          )}
        </div>
      ),
    },
    {
      title: `${t("Сумма")}, $`,
      dataIndex: `amount`,
      width: 100,
      render: (text: any) => (
        <div className={s.font}>
          {text.transaction_type === "credit" ? (
            <NumericFormat
              className={s.font}
              style={{ color: "rgb(72, 157, 72)" }}
              value={text.amount}
              displayType="text"
              thousandSeparator=" "
            />
          ) : text.transaction_type === "debit" ? (
            <div style={{ color: "#FA5F55" }}>
              -&nbsp;
              <NumericFormat
                className={s.font}
                value={text.amount}
                displayType="text"
                thousandSeparator=" "
              />
            </div>
          ) : (
            <div className={s.font}> - {text.amount}</div>
          )}
        </div>
      ),
    },
    {
      title: t("Итого, $"),
      dataIndex: `row_balance`,
      width: 100,
      render: (text) => (
        <NumericFormat
          className={s.font_bold}
          value={text}
          displayType="text"
          thousandSeparator=" "
        />
      ),
    },
  ];

  const addBalance = async () => {
    if (alltransactions) {
      const res = await dispatch(
        addPartnerBalance({
          user_email: alltransactions.email,
          amount: Number(balanceToAdd),
        })
      );

      if (res.type === "billing/addPartnerBalance/fulfilled") {
        dispatch(getTransactionsHistory({ user_id: alltransactions.user_id }));
        setIsModalOpen(false);
        setBalanceToAdd(0);
      }
    }
  };
  const reduceBalance = async () => {
    if (alltransactions) {
      const res = await dispatch(
        reducePartnerBalance({
          user_email: alltransactions.email,
          amount: Number(balanceToReduce),
        })
      );

      if (res.type === "billing/reducePartnerBalance/fulfilled") {
        dispatch(getTransactionsHistory({ user_id: alltransactions.user_id }));
        setIsReduceModalOpen(false);
        setBalanceToReduce(0);
      }
    }
  };
  return (
    <div className={s.balance_wrapper}>
      {width > 985 ? <Header /> : <MobileHeader />}
      <div className={s.balance}>
        <div className={s.balance_header}>
          <div>
            <div className={s.top_balance}>
              <div className={s.total_balance}>
                {user?.role === "regional_manager" ? (
                  <div
                    className={
                      partnerBalance?.balance &&
                      Number(partnerBalance?.balance) > 0
                        ? s.balance_value
                        : s.negative_balance_value
                    }
                  >
                    <NumericFormat
                      className={
                        partnerBalance?.balance &&
                        Number(partnerBalance?.balance) > 0
                          ? s.balance_value
                          : s.negative_balance_value
                      }
                      value={partnerBalance?.balance}
                      displayType="text"
                      thousandSeparator=" "
                    />{" "}
                    $
                  </div>
                ) : (
                  <div
                    className={
                      alltransactions?.current_balance &&
                      alltransactions?.current_balance > 0
                        ? s.balance_value
                        : s.negative_balance_value
                    }
                  >
                    <NumericFormat
                      className={
                        alltransactions?.current_balance &&
                        alltransactions?.current_balance > 0
                          ? s.balance_value
                          : s.negative_balance_value
                      }
                      value={alltransactions?.current_balance}
                      displayType="text"
                      thousandSeparator=" "
                    />{" "}
                    $
                  </div>
                )}
                <div className={s.balance_header_subtitle}>
                  {t("Текущий баланс")}
                </div>
              </div>
              {user?.role === "admin" && (
                <div className={s.balance_buttons}>
                  <button className={s.top_btn} onClick={showModal}>
                    {t("Пополнение")}
                  </button>
                  <button className={s.top_btn} onClick={showReduceModal}>
                    {t("Списание")}
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className={s.datepicker}>
            <Space direction="vertical" size={12}>
              <RangePicker format="DD-MM-YYYY" onChange={handleChange} />
            </Space>
            <button
              className={s.btn}
              onClick={() =>
                dispatch(
                  getTransactionsHistory({
                    start_date: startDate,
                    end_date: endDate,
                    user_id: alltransactions?.user_id,
                  })
                )
              }
            >
              {t("Найти")}
            </button>
          </div>
        </div>
        <div className={s.balance_table}>
          <div className={s.table}>
            <div
              style={{
                padding: "10px",
                background: "#f5f5f5",
                marginTop: "10px",
              }}
            ></div>
            <div className={s.form}>
              <Table<ITable>
                bordered
                pagination={false}
                columns={columns}
                className="table"
                onChange={onChange}
                dataSource={alltransactions?.transactions.map((it, index) => ({
                  number: index + 1,
                  transaction_type: it?.transaction_type,
                  application_number: it?.application?.application_number,
                  date: moment(it?.transaction_date).format("DD.MM.YYYY"),
                  amount: it,
                  row_balance: it?.balance_after_transaction,
                }))}
              />
            </div>
          </div>
        </div>
      </div>
      <Modal
        title={t("Пополнить баланс, $")}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <div className={s.modal}>
          <Input
            className={s.input}
            placeholder={t("Укажите сумму")}
            type="number"
            onChange={(e: any) => setBalanceToAdd(e.target.value)}
          />
          <Popconfirm
            placement="bottomRight"
            title={t(`Проверьте данные`)}
            description={`Пополнить баланс на ${balanceToAdd} $?`}
            okText="Ok"
            cancelText={t("Отмена")}
            onConfirm={addBalance}
          >
            <Button className={s.add_btn}>{t("Пополнить")}</Button>
          </Popconfirm>
        </div>
      </Modal>
      <Modal
        title={t("Cписать с баланса, $")}
        open={isReduceModalOpen}
        onCancel={handleReduceCancel}
        footer={null}
      >
        <div className={s.modal}>
          <Input
            className={s.input}
            placeholder={t("Укажите сумму")}
            type="number"
            onChange={(e: any) => setBalanceToReduce(e.target.value)}
          />
          <Popconfirm
            placement="bottomRight"
            title={t(`Проверьте данные`)}
            description={`Списать с баланса ${balanceToReduce} $?`}
            okText={t("Ok")}
            cancelText={t("Отмена")}
            onConfirm={reduceBalance}
          >
            <Button className={s.add_btn}>{t("Списать")}</Button>
          </Popconfirm>
        </div>
      </Modal>
      <Footer />
    </div>
  );
};

export default Balance;
